import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_xefwj7gp89: FaireBrandEntity = {
  token: "b_xefwj7gp89",
  type: "brand",
  name: "Saturn Press",
  avatarUrl:
    "https://cdn.faire.com/fastly/9ea11d43e5057d28064523a02dfc9cef695494ce3a325e81a66b406f647f02ea.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/707cb5a8d955b10544a026793afd559beb1d0365d991d809f8a431fe63f53fe6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9ea11d43e5057d28064523a02dfc9cef695494ce3a325e81a66b406f647f02ea.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/707cb5a8d955b10544a026793afd559beb1d0365d991d809f8a431fe63f53fe6.jpeg",
  location: "Kent, CT, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 41,
  isTopShop: true,
  isInsider: true,
  description:
    "Saturn Press is a family-owned business that designs and prints letterpress greeting cards and stationery in a restored 1821 church in the Litchfield Hills of Connecticut. \n\nOur presses are antique machines dating from the mid 1900s — brought from Swan's Island, Maine, where Saturn Press was founded in 1986.  We keep running these analog presses because nothing else produces quite the same visual results.  \n\nOur designs are inspired by our extensive ephemera collection - we start with illustrations, vintage stamps, sometimes old greeting cards; we strip away the detail to reveal the essentials - and to make them work for letterpress.  Our goal is an image that feels timeless - never old-fashioned - but hopefully familiar to the customer. \n\nOur line runs to almost two hundred designs across everyday, humor, nature, and Holiday. Independent retailers tell us our cards sell because customers pick them up, feel them, and can't put them down.\n\nWe're proud to serve independent bookstores, museum shops, and gift stores across the country...and increasingly across the world - all from our old church in the Litchfield Hills.\n\nWe're so glad you stopped by our Faire store - we hope you'll decide to stay awhile and find a place for Saturn Press in your store.\n\nJames and Deirdre Anderson\nOwners\n\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:06.995Z",
    importedBy: "entity-db-cli",
  },
};
